import type {ReactElement} from 'react';
import {Pill} from '@Components/pill/pill';
import {PillSize} from '@Components/pill/pill.types';
import {Text, TextSize} from '@Components/text';
import {AiChatTestId} from '@/test-ids/ai-chat-test-id';
import {formatTargetSizeLabel, isReducedPrintDpi} from '@Libraries/ai-chat-target-size.library';
import type {GeneratedImageSizeChipProps} from './generated-image-size-chip.types';

export function GeneratedImageSizeChip({size}: GeneratedImageSizeChipProps): ReactElement {
  const renderReducedDpiNote = (): ReactElement | null => {
    if (!isReducedPrintDpi(size)) {
      return null;
    }

    return <Text size={TextSize.SM} className="content-sub-text" val={window.i18next.t('pmwjs_ai_chat_size_reduced_dpi', {dpi: size.dpi})} />;
  };

  return (
    <div className="flex-v-row align-items-start gap-1 spacing-m-t-2">
      <Pill label={formatTargetSizeLabel(size)} size={PillSize.SM} data-testid={AiChatTestId.GENERATED_IMAGE_SIZE_CHIP} />
      {renderReducedDpiNote()}
    </div>
  );
}
